import ClaimPage from "views/Pages/ClaimPage.jsx";

var pagesRoutes = [
  {
    path: "/",
    name: "Claim Page",
    mini: "CP",
    component: ClaimPage,
  },
];

export default pagesRoutes;



// WEBPACK FOOTER //
// ./src/routes/pages.jsx